export default __webpack_public_path__ + "static/media/rambouillet15.378a4a0a.jpg";